import PropTypes from 'prop-types'
import { formatNumber } from '../../utils/function.utils'
import './CardChart.scss'
// import { ChartItem } from './Chart/Chart'
export const CardChart = ({
	title = 'Card Chart Title',
	subtitle,

	number = 0,
	subNumber,
	formatNumberFn,
	color = 'primary',
	// chartID,
	onClick,
	route,
}) => {
	const isClickable = Boolean(route && onClick)
	const handleClick = () => {
		if (isClickable) {
			onClick(route)
		}
	}
	const fmt = formatNumberFn ?? formatNumber
	const showSecondRow = subtitle != null || subNumber != null

	return (
		<div
			className={`card-chart ${color}${
				isClickable ? ' card-chart--clickable' : ''
			}`}
			onClick={isClickable ? handleClick : undefined}
			role={isClickable ? 'button' : undefined}
			tabIndex={isClickable ? 0 : undefined}
			onKeyDown={
				isClickable
					? e => {
							if (e.key === 'Enter' || e.key === ' ') {
								e.preventDefault()
								handleClick()
							}
					  }
					: undefined
			}
		>
			<div className="detail-wrapper">
				<div className="text-description">{title}</div>
				<div className="text-value">{fmt(number)}</div>
			</div>
			{showSecondRow && (
				<div className="detail-wrapper">
					<div className="text-description">{subtitle}</div>
					<div className="text-value">{fmt(subNumber)}</div>
				</div>
			)}
			<div className="chart-wrapper">
				{/* <ChartItem chartID={chartID} /> */}
			</div>
		</div>
	)
}

CardChart.propTypes = {
	title: PropTypes.string,
	number: PropTypes.number,
	color: PropTypes.string,
	chartID: PropTypes.string,
	onClick: PropTypes.func,
	route: PropTypes.any,
}
